var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$userInfo
    ? _c(
        "div",
        [
          _c("app-detail-header", {
            attrs: {
              "show-toggle": true,
              "show-delete": false,
              "show-save": false,
              "show-cancel": false,
              "show-new": true,
              "show-print": false,
              "show-calendar": true,
            },
            on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
          }),
          _c("div", { staticClass: "columns is-gapless" }, [
            _c(
              "div",
              { staticClass: "column is-narrow" },
              [
                _c("booking-list-side-menu", {
                  on: { filter: _vm.filterList, reset: _vm.resetList },
                  model: {
                    value: _vm.filter,
                    callback: function ($$v) {
                      _vm.filter = $$v
                    },
                    expression: "filter",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "column" }, [
              _c("div", { staticClass: "tile is-parent" }, [
                _c(
                  "article",
                  { staticClass: "tile is-child box" },
                  [
                    _vm.isRepxEnabled
                      ? _c(
                          "div",
                          {
                            staticClass: "columns",
                            staticStyle: { "margin-left": "0rem" },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("v-date-picker", {
                                  attrs: {
                                    "is-dark": _vm.$theme.isDark,
                                    masks: _vm.formats,
                                    attributes: _vm.attrs,
                                    "model-config": _vm.modelConfig,
                                    locale: _vm.$userInfo.locale,
                                    timezone: _vm.$filters.getIanaTimezone(),
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({
                                          inputValue,
                                          inputEvents,
                                        }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "control has-icons-left",
                                                  },
                                                  [
                                                    _c(
                                                      "input",
                                                      _vm._g(
                                                        {
                                                          staticClass: "input",
                                                          attrs: {
                                                            type: "text",
                                                            placeholder:
                                                              "Date...",
                                                          },
                                                          domProps: {
                                                            value: inputValue,
                                                          },
                                                        },
                                                        inputEvents
                                                      )
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "icon is-small is-left",
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "mdi mdi-calendar mdi-18px",
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    4229296700
                                  ),
                                  model: {
                                    value: _vm.pullDate,
                                    callback: function ($$v) {
                                      _vm.pullDate = $$v
                                    },
                                    expression: "pullDate",
                                  },
                                }),
                                _c("p", [
                                  _vm._v("Select date to fetch data from RepX"),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "field is-grouped is-pulled-right",
                              },
                              [
                                _c("div", { staticClass: "control" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "button is-primary",
                                      on: { click: _vm.onPullClick },
                                    },
                                    [_vm._m(0), _c("span", [_vm._v("Fetch")])]
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "bulma-table",
                      {
                        staticClass:
                          "table is-bordered is-striped is-narrow is-fullwidth",
                        attrs: {
                          columns: _vm.columns,
                          "page-index": _vm.filter.pageIndex,
                          "page-size": _vm.filter.pageSize,
                          "total-rows": _vm.totalRows,
                          "is-loading": _vm.isTableLoading,
                          "sort-column": _vm.filter.sortColumn,
                          "sort-order": _vm.filter.sortOrder,
                        },
                        on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
                      },
                      [
                        _vm._l(_vm.entities, function (booking, index) {
                          return _c(
                            "tr",
                            {
                              key: booking.quoteBookingID,
                              class: {
                                "is-selected": _vm.selectedRow === index,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.highlightSelected(index, $event)
                                },
                              },
                            },
                            [
                              _c(
                                "td",
                                [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: {
                                          path: `/booking/${booking.quoteBookingID}`,
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            booking.vehicleRegistrationNo
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c("td", [_vm._v(_vm._s(booking.claimNo))]),
                              _c("td", [
                                _c(
                                  "a",
                                  {
                                    staticClass: "button is-fullwidth",
                                    class: [
                                      booking.quoteId != null
                                        ? "is-primary"
                                        : !!booking.attempts
                                        ? "is-danger"
                                        : "is-success",
                                    ],
                                    on: {
                                      click: function ($event) {
                                        booking.quoteId != null
                                          ? _vm.handleQuoteClick(
                                              booking.quoteId
                                            )
                                          : _vm.handleBookingClick(
                                              booking.quoteBookingID
                                            )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          booking.quoteId != null
                                            ? booking.quoteNo
                                            : !!booking.attempts
                                            ? "RETRY"
                                            : "NEW"
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-centered" }, [
                                _vm._v(
                                  _vm._s(
                                    booking.attempts == "0"
                                      ? ""
                                      : booking.attempts
                                  )
                                ),
                              ]),
                              _c("td", [_vm._v(_vm._s(booking.customerName))]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      booking.excess,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatDateTimeLocale(
                                      booking.bookingStartDateTime,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatDateTimeLocale(
                                      booking.bookingEndDateTime,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatDateLocale(
                                      booking.createdDate,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-centered" }, [
                                _vm._v(_vm._s(booking.deleted ? "Yes" : "No")),
                              ]),
                              _c(
                                "td",
                                { staticClass: "has-text-centered" },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: {
                                          path: `${booking.quoteBookingID}`,
                                        },
                                        append: "",
                                      },
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "button is-primary is-small is-inverted tooltip",
                                          attrs: {
                                            "data-tooltip": "Click to edit",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "icon is-medium" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "mdi mdi-lead-pencil mdi-24px",
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        }),
                        _c("template", { slot: "empty" }, [
                          _c("section", { staticClass: "section" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "content has-text-grey has-text-centered",
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { icon: "icon is-large" } },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "mdi mdi-48px mdi-emoticon-sad",
                                    }),
                                  ]
                                ),
                                _c("p", [_vm._v("Nothing")]),
                              ]
                            ),
                          ]),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _c("booking-simple-view-modal", {
            attrs: {
              active: _vm.isSimpleBookingModelActive,
              "booking-id": _vm.selectedEditBookingId,
              visible: _vm.isSimpleBookingModelActive,
              "is-new": _vm.isNewSimpleBooking,
              "trigger-convert": _vm.triggerConvert,
            },
            on: {
              "update:active": function ($event) {
                _vm.isSimpleBookingModelActive = $event
              },
              close: _vm.handleSimpleBookingModalClosed,
              save: _vm.handleSimpleBookingSave,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-cloud-download mdi-18px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }